import {
  InternalLinks,
} from '@tenants/types/tenant';
import { ROOT_PATH_SUFFIX } from 'data/addresses/go-search/types';
import {
  ProvinceAndState,
  ProvinceAndStateMappings,
  stateSlugMappings,
} from 'utils/province_or_state';

export function createPopularUsCitiesLinks(rootPathSuffix: string = ROOT_PATH_SUFFIX): InternalLinks {
  return {
    title: 'Popular US Cities',
    links: [
      {
        label: 'New York',
        link: `/new-york-${ProvinceAndState.NY.toLowerCase()}-${rootPathSuffix}`,
      },
      {
        label: 'Los Angeles',
        link: `/los-angeles-${ProvinceAndState.CA.toLowerCase()}-${rootPathSuffix}`,
      },
      {
        label: 'Chicago',
        link: `/chicago-${ProvinceAndState.IL.toLowerCase()}-${rootPathSuffix}`,
      },
      {
        label: 'Houston',
        link: `/houston-${ProvinceAndState.TX.toLowerCase()}-${rootPathSuffix}`,
      },
      {
        label: 'Phoenix',
        link: `/phoenix-${ProvinceAndState.AZ.toLowerCase()}-${rootPathSuffix}`,
      },
      {
        label: 'Philadelphia',
        link: `/philadelphia-${ProvinceAndState.PA.toLowerCase()}-${rootPathSuffix}`,
      },
      {
        label: 'San Antonio',
        link: `/san-antonio-${ProvinceAndState.TX.toLowerCase()}-${rootPathSuffix}`,
      },
      {
        label: 'San Diego',
        link: `/san-diego-${ProvinceAndState.CA.toLowerCase()}-${rootPathSuffix}`,
      },
      {
        label: 'Dallas',
        link: `/dallas-${ProvinceAndState.TX.toLowerCase()}-${rootPathSuffix}`,
      },
      {
        label: 'San Jose',
        link: `/san-jose-${ProvinceAndState.CA.toLowerCase()}-${rootPathSuffix}`,
      },
    ],
  };
}

export function createPopularUsStatesLinks(rootPathSuffix: string = ROOT_PATH_SUFFIX): InternalLinks {
  return {
    title: 'Popular US States',
    links: [
      {
        label: ProvinceAndStateMappings.al,
        link: `/${stateSlugMappings.al}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.ak,
        link: `/${stateSlugMappings.ak}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.az,
        link: `/${stateSlugMappings.az}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.ar,
        link: `/${stateSlugMappings.ar}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.ca,
        link: `/${stateSlugMappings.ca}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.co,
        link: `/${stateSlugMappings.co}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.ct,
        link: `/${stateSlugMappings.ct}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.de,
        link: `/${stateSlugMappings.de}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.fl,
        link: `/${stateSlugMappings.fl}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.ga,
        link: `/${stateSlugMappings.ga}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.hi,
        link: `/${stateSlugMappings.hi}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.id,
        link: `/${stateSlugMappings.id}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.il,
        link: `/${stateSlugMappings.il}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.in,
        link: `/${stateSlugMappings.in}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.ia,
        link: `/${stateSlugMappings.ia}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.ks,
        link: `/${stateSlugMappings.ks}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.ky,
        link: `/${stateSlugMappings.ky}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.la,
        link: `/${stateSlugMappings.la}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.me,
        link: `/${stateSlugMappings.me}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.md,
        link: `/${stateSlugMappings.md}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.ma,
        link: `/${stateSlugMappings.ma}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.mi,
        link: `/${stateSlugMappings.mi}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.mn,
        link: `/${stateSlugMappings.mn}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.ms,
        link: `/${stateSlugMappings.ms}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.mo,
        link: `/${stateSlugMappings.mo}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.mt,
        link: `/${stateSlugMappings.mt}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.ne,
        link: `/${stateSlugMappings.ne}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.nv,
        link: `/${stateSlugMappings.nv}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.nh,
        link: `/${stateSlugMappings.nh}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.nj,
        link: `/${stateSlugMappings.nj}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.nm,
        link: `/${stateSlugMappings.nm}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.ny,
        link: `/${stateSlugMappings.ny}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.nc,
        link: `/${stateSlugMappings.nc}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.nd,
        link: `/${stateSlugMappings.nd}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.oh,
        link: `/${stateSlugMappings.oh}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.ok,
        link: `/${stateSlugMappings.ok}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.or,
        link: `/${stateSlugMappings.or}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.pa,
        link: `/${stateSlugMappings.pa}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.ri,
        link: `/${stateSlugMappings.ri}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.sc,
        link: `/${stateSlugMappings.sc}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.sd,
        link: `/${stateSlugMappings.sd}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.tn,
        link: `/${stateSlugMappings.tn}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.tx,
        link: `/${stateSlugMappings.tx}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.ut,
        link: `/${stateSlugMappings.ut}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.vt,
        link: `/${stateSlugMappings.vt}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.va,
        link: `/${stateSlugMappings.va}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.wa,
        link: `/${stateSlugMappings.wa}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.wv,
        link: `/${stateSlugMappings.wv}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.wi,
        link: `/${stateSlugMappings.wi}-${rootPathSuffix}`,
      },
      {
        label: ProvinceAndStateMappings.wy,
        link: `/${stateSlugMappings.wy}-${rootPathSuffix}`,
      },
    ],
  };
}